<template>
  <v-container fluid class="container">
    <Breadcrumbs
      :items="breadcrumbs"/>
    <v-toolbar flat>
      <ejs-dropdownlist v-if="!lcyIsEur" id='bs_currency' :dataSource='currencyDropdownDataSource'
                        :change='onCurrencyDropdownChange' v-model="currencyDropdown"
                        placeholder='Currency' width='130' class="pr-4"></ejs-dropdownlist>
      <ejs-dropdownlist id='bs_pdf_layout' :dataSource='pdfLayoutDropdownDataSource'
                        :change='onPdfLayoutDropdownChange' v-model="pdfLayoutDropdown"
                        placeholder='Layout' width='150' class="pr-4"></ejs-dropdownlist>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click='excelDownloadClick'>
        Export to Excel
      </v-btn>
    </v-toolbar>
    <v-spacer></v-spacer>
    <ejs-treegrid  id="grid1" ref="grid"  :dataSource='items' v-if='items' childMapping='sub'  :allowResizing='true' :enableCollapseAll='false'
                  :pageSettings='pageSettings' :allowPaging='true'
                  :allowTextWrap="true" :treeColumnIndex='0' :allowExcelExport='true' :excelHeaderQueryCellInfo='excelHeader'
                  :allowFiltering='true' :filterSettings="{type: 'Menu'}">
        <e-columns>
            <e-column field='summary_pos' headerText='Summary - Position Mapping' width='240'></e-column>
            <e-column field='position' headerText='Position' width='190'></e-column>
            <e-column textAlign='center' :columns='valuesColumns'>
            </e-column>
        </e-columns>
    </ejs-treegrid>
    <br>
    <ejs-treegrid id="grid2" ref="grid2" :dataSource='resultItems' childMapping='sub'
                  :treeColumnIndex='0'  :allowExcelExport='true' :excelHeaderQueryCellInfo='excelHeader'>
      <e-columns>
        <e-column field='description' headerText='Description' width='300'></e-column>
        <e-column field='res' headerText='' width='300'></e-column>
        <e-column textAlign='center' :columns='columnItems'></e-column>
      </e-columns>
    </ejs-treegrid>
    <Snackbar :text="notificationText"
      :type="notificationType" />
    <v-overlay :value="loader"
      :z-index="1000">
      <v-progress-circular indeterminate
        size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import {
  TreeGridPlugin, ExcelExport, Page, Resize, Filter,
} from '@syncfusion/ej2-vue-treegrid';
import Breadcrumbs from '@/components/Breadcrumbs';
import Snackbar from '@/components/Snackbar';
import api from '../api/lbt-api';

Vue.use(TreeGridPlugin);

const {
  getSummaryBSForPlanning,
} = api;

export default {
  name: 'SummaryPortfolio',
  components: {
    Breadcrumbs,
    Snackbar,
  },
  data() {
    return {
      notificationText: '',
      loader: false,
      notificationType: null,
      headers: [],
      items: [],
      expanded: [],
      resultItems: [],
      columnItems: [],
      breadcrumbs: [
        {
          translationKey: 'breadcrumbs_plannings',
          route: '/plannings',
          disabled: false,
        },
        {
          translationKey: 'summary B&S',
          disabled: true,
        },
      ],
      valuesColumns: [],
      highlightCellAttributes: { class: 'highlight-cell' },
      pageSettings: { pageSizes: true, pageSize: 100 },
      currencyDropdown: 'LCY',
      currencyDropdownValue: 'LCY',
      currencyDropdownDataSource: ['LCY', 'EUR'],
      pdfLayoutDropdown: 'Regular',
      pdfLayoutDropdownValue: false,
      pdfLayoutDropdownDataSource: ['Regular', 'PDF Layout'],
    };
  },
  computed: {
    ...mapGetters('translations', [
      'translate',
    ]),
    ...mapState('plannings', [
      'activePlanning',
    ]),
    lcyIsEur() {
      const lcy = this.activePlanning && this.activePlanning.lcy_option;
      return lcy && lcy.option === 'EUR';
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loader = true;
      this.valuesColumns = [];
      try {
        const planning = await getSummaryBSForPlanning(
          this.$route.params.planningId,
          this.currencyDropdownValue,
          this.pdfLayoutDropdownValue,
        );
        this.headers = planning.periods;
        this.items = planning.rows;
        this.prepareValuesGridHeaders();
        this.updateResultItems();
      } catch (message) {
        this.notificationText = message;
        this.notificationType = 'error';
        setTimeout(() => { this.notificationText = null; }, 100);
      } finally {
        this.loader = false;
      }
    },
    onCurrencyDropdownChange(selected) {
      this.currencyDropdownValue = selected.value;
      setTimeout(this.fetchData, 100);
    },
    onPdfLayoutDropdownChange(selected) {
      this.pdfLayoutDropdownValue = selected.value === 'PDF Layout';
      setTimeout(this.fetchData, 100);
    },
    prepareValuesGridHeaders() {
      const item = this.items[0];
      for (let i = 0; i < item.values.length; i += 1) {
        this.valuesColumns.push({
          field: `values.${i}`,
          headerText: i,
          headerValueAccessor: this.lookupValuesHeader,
          customAttributes: this.highlightCellAttributes,
          width: 60,
          format: 'n2',
          textAlign: 'right',
          allowFiltering: false,
        });
      }
    },
    lookupValuesHeader(idx) {
      return this.headers[Number(idx)];
    },
    excelDownloadClick() {
      const appendExcelExportProperties = {
        multipleExport: { type: 'AppendToSheet', blankRows: 5 },
        fileName: `Summary BS- ${this.activePlanning.year}-${this.activePlanning.month}.xlsx`,
      };
      const firstGridExport = this.$refs.grid.excelExport(appendExcelExportProperties, true);
      firstGridExport.then((fData) => {
        this.$refs.grid2.excelExport(appendExcelExportProperties, false, fData);
      });
    },
    excelHeader(args) {
      const { cell } = args;
      if (cell.index > 2) {
        cell.value = this.headers[cell.value];
      }
    },
    updateResultItems() {
      const row10 = this.items.length > 5 ? this.items[5].values : [];
      const row5 = this.items.length > 10 ? this.items[10].values : [];
      const differences = row10.map((value, index) => value - (row5[index] || 0));
      if (row10.length && row5.length) {
        // Prepare a single row with each index's difference
        this.resultItems = [{
          description: 'Assets=Liabilities+Equity',
          ...differences.reduce((acc, diff, index) => ({ ...acc, [`diff${index}`]: diff }), {}),
        }];
      }
      this.columnItems = differences.map((_, index) => ({
        field: `diff${index}`,
        headerText: this.headers[Number(index)],
        width: 100,
        textAlign: 'Right',
        format: 'N2',
      }));
    },
  },
  provide: {
    treegrid: [ExcelExport, Page, Resize, Filter],
  },
};
</script>

<style>
  @import '../../node_modules/@syncfusion/ej2-vue-treegrid/styles/material.css';

  .e-grid .e-headercell.highlight-cell, .highlight-cell {
    background: #eeeeee;
  }
  .e-headercelldiv {
    text-align: center !important;
  }
</style>
